export function getQueryParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i'), results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function updateQueryStringParameter(uri, key, value) {
    const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
    }
    else {
        return uri + separator + key + '=' + value;
    }
}

export function serializeObjectToQueryStringParameters(uri, object) {
    Object.keys(object).forEach(key => uri = updateQueryStringParameter(uri, key, object[key]));
    return uri;
}

export function getQueryParamByName(qpName, fullUrl = window.location.href) {
    const queryParams = new URL(fullUrl).searchParams;
    const qpValue = queryParams.get(qpName);

    return qpValue;
}